import { all, select, takeEvery } from 'redux-saga/effects';
import { Action } from 'typescript-fsa';
import { getBettingUserApi2, getProfileApi, getSystemConfig } from '../../components/System/systemConfig';
import { fetchWrapperFuncNoLoading } from '../../utils';
import { userLinkSet, userLinkSetUserImage, USER_LINK_LOAD, USER_LINK_LOAD_USER_IMAGE } from './actions';
import { userLinkEntitySelector, userLinkUserImageSelector } from './selectors';

function* load(action: Action<string>): any {
    const userId = action.payload;

    const api = getBettingUserApi2();
    const userInfo = yield select(userLinkEntitySelector(userId));

    if (!userInfo) {
        yield* fetchWrapperFuncNoLoading(() => api.getBettingUserProfileById(userId), [r => userLinkSet(r)]);
    }
}

function* loadUserImage(action: Action<string>) {
    const userId = action.payload;

    const api = getProfileApi();
    const userImage: string = yield select(userLinkUserImageSelector(userId));

    if (!userImage) {
        yield* fetchWrapperFuncNoLoading(() => api.getUserImage(getSystemConfig().clientName, userId), [
            r => userLinkSetUserImage({ userId, imageId: r })
        ]);
    }
}

function* watch() {
    yield takeEvery(USER_LINK_LOAD, load);
    yield takeEvery(USER_LINK_LOAD_USER_IMAGE, loadUserImage);
}

export function* userLinkSagas() {
    yield all([watch()]);
}
